import { render, staticRenderFns } from "./renewalordersDetail.vue?vue&type=template&id=673b13f1&scoped=true&"
import script from "./renewalordersDetail.vue?vue&type=script&lang=js&"
export * from "./renewalordersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b13f1",
  null
  
)

export default component.exports